import SDP from 'react-dates/lib/components/SingleDatePicker';
import { ArrowLeft, ArrowRight } from '@jsluna/icons';
import React from 'react';
import PropTypes from 'prop-types';
import DRP from 'react-dates/lib/components/DateRangePicker';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var NavPrev = function NavPrev() {
  return /*#__PURE__*/React.createElement("div", {
    className: "ln-c-date-picker__nav-prev"
  }, /*#__PURE__*/React.createElement(ArrowLeft, {
    "aria-hidden": true
  }));
};

NavPrev.displayName = 'NavPrev';

var NavNext = function NavNext() {
  return /*#__PURE__*/React.createElement("div", {
    className: "ln-c-date-picker__nav-next"
  }, /*#__PURE__*/React.createElement(ArrowRight, {
    "aria-hidden": true
  }));
};

NavNext.displayName = 'NavNext';

// eslint-disable-next-line import/prefer-default-export
var WEEK_DAY_FORMAT = 'ddd';

/**
 * @see Take a look at [Airbnb's documentation](https://github.com/airbnb/react-dates#daterangepicker) for information on how to customise and configure this component.
 */

var SingleDatePicker = function SingleDatePicker(_ref) {
  var element = _ref.element,
      showKeyboardShortcutsPanel = _ref.showKeyboardShortcutsPanel,
      props = _objectWithoutPropertiesLoose(_ref, ["element", "showKeyboardShortcutsPanel"]);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, {
    className: "ln-c-date-picker"
  }, /*#__PURE__*/React.createElement(SDP, _extends({
    navPrev: /*#__PURE__*/React.createElement(NavPrev, null),
    navNext: /*#__PURE__*/React.createElement(NavNext, null),
    weekDayFormat: WEEK_DAY_FORMAT,
    hideKeyboardShortcutsPanel: !showKeyboardShortcutsPanel,
    numberOfMonths: 1
  }, props)));
};

SingleDatePicker.propTypes = {
  element: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string]),
  showKeyboardShortcutsPanel: PropTypes.bool
};
SingleDatePicker.defaultProps = {
  element: 'div',
  showKeyboardShortcutsPanel: false
};
SingleDatePicker.displayName = 'SingleDatePicker';

/**
 * @see Take a look at [Airbnb's documentation](https://github.com/airbnb/react-dates#daterangepicker) for information on how to customise and configure this component.
 */

var DateRangePicker = function DateRangePicker(_ref) {
  var element = _ref.element,
      showKeyboardShortcutsPanel = _ref.showKeyboardShortcutsPanel,
      props = _objectWithoutPropertiesLoose(_ref, ["element", "showKeyboardShortcutsPanel"]);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, {
    className: "ln-c-date-picker"
  }, /*#__PURE__*/React.createElement(DRP, _extends({
    navPrev: /*#__PURE__*/React.createElement(NavPrev, null),
    navNext: /*#__PURE__*/React.createElement(NavNext, null),
    weekDayFormat: WEEK_DAY_FORMAT,
    hideKeyboardShortcutsPanel: !showKeyboardShortcutsPanel,
    numberOfMonths: 1,
    keepOpenOnDateSelect: true
  }, props)));
};

DateRangePicker.propTypes = {
  element: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string]),
  showKeyboardShortcutsPanel: PropTypes.bool
};
DateRangePicker.defaultProps = {
  element: 'div',
  showKeyboardShortcutsPanel: false
};
DateRangePicker.displayName = 'DateRangePicker';

export { SingleDatePicker, DateRangePicker };
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/date-picker/dist/index.js
// module id = 520
// module chunks = 0